import BaseConfigApi from "../BaseConfigApi";

export default abstract class BaseTeamApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/team`;
	}
}
